const sleep = async (timeInMs) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            return resolve(true);
        }, timeInMs);
    });
};
export default sleep;
